export async function showEntityModal($uibModal, {
	entity,
	typeConfig,
	permissions,
	mode,
	syncUrl
}) {
	const modal = $uibModal.open({
		component: "entity-modal",
		size: "lg",
		backdrop: "static",
		keyboard: false,
		resolve: {
			entity: () => entity,
			typeConfig: () => typeConfig,
			permissions: () => permissions,
			mode: () => mode,
			syncUrl: () => syncUrl
		}
	});

	try {
		return await modal.result;
	}
	finally {
		await modal.closed;
	}
}
